const credit = () => {
    console.info("%c Développement : Aurélien Chappard - Deefuse %c ⟹ https://www.deefuse.fr", "font-family: Gill Sans, sans-serif;font-size:16px; background:#000; color:#FFFFFF", "background:none");
    console.info("%c Création graphique : Zeecom %c ⟹ https://www.zeecom.fr", "font-family: Gill Sans, sans-serif;font-size:16px; background:#000; color:#FFFFFF", "background:none");
}
export {credit};
